import React, { ReactNode } from 'react';
import styles from './WindowPreviewImage.module.scss';

export const WindowPreviewImage = ({ children }: Props) => (
    <div className={styles.default}>
        {children}
    </div>
);

type Props = {
    children: ReactNode;
};